import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';
import { UAT_DATA } from 'src/app/constants/endpoint.const';
import { BaseService } from 'src/app/services/base.service';
import { UatPaymentDataType, UatPaymentMethodResponseType } from 'src/app/types/response/document-state.response.type';

@Component({
  standalone: false,
  selector: 'app-uat-cancel-payment',
  templateUrl: './uat-cancel-payment.component.html',
  styleUrl: './uat-cancel-payment.component.scss'
})
export class UatCancelPaymentComponent implements OnChanges {
  destroy$: Subject<void> = new Subject<void>();
  @Input() uatPaymentMethod: UatPaymentMethodResponseType[] = [];
  @Input() uatData: UatPaymentDataType[] = [];
  cancelPaymentForm!: FormGroup;
  current: number = 5;
  @Output() submitUATFinal = new EventEmitter

  constructor(private baseService: BaseService, private fb: FormBuilder, private router: Router) {
    this.initForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['uatPaymentMethod'] && this.uatPaymentMethod?.length > 0) {
      if (!this.cancelPaymentForm) {
        this.cancelPaymentForm = this.fb.group({});
      }
      this.uatPaymentMethod.forEach(item => {
        if (!this.cancelPaymentForm.contains(`curl_${item.id}`)) {
          this.cancelPaymentForm.addControl(`curl_${item.id}`, this.fb.control(null, Validators.required));
          this.cancelPaymentForm.addControl(`result_${item.id}`, this.fb.control(null, Validators.required));
        }
      });
    }

    if ((changes['uatData'] || changes['uatPaymentMethod']) && this.uatData?.length > 0 && this.cancelPaymentForm) {
      this.uatPaymentMethod.forEach(method => {
        const data = this.uatData.find(d => d.test_case_id === method.id);
        if (data) {
          this.cancelPaymentForm.patchValue({
            [`curl_${method.id}`]: data.curl,
            [`result_${method.id}`]: data.result
          });
          method.notes = data.notes;
        }
      });
    }
  }

  initForm() {
    this.cancelPaymentForm = this.fb.group({});
  }

  next(): void {
    this.submitUat()
  }
  previus(): void {
    if (this.current > 1) {
      this.router.navigate(['/document/uat-data-input-payment'], { queryParams: { step: this.current - 1 } });
    }
  }

  submitUat() {
    const input = this.uatPaymentMethod.map(item => ({
      test_case_id: item.id,
      curl: this.cancelPaymentForm.get(`curl_${item.id}`)?.value,
      result: this.cancelPaymentForm.get(`result_${item.id}`)?.value,
      service_types_id: 2
    }));

      this.baseService
        .postData(UAT_DATA, { input })
        .pipe(takeUntil(this.destroy$))
        .subscribe({
          next: (res: any) => {
            this.submitUATFinal.emit()
            this.router.navigate([['/document']])
            localStorage.setItem('uat-cancel-payment', 'complete')
            localStorage.removeItem('mode-uat-input-payment')
          },
          error: (err) => console.error(err.error.data.errors),
        });
    }

  formatJson(val: any): string {
    if (!val) return '-';
    try {
      const parsed = typeof val === 'string' ? JSON.parse(val) : val;
      return JSON.stringify(parsed, null, 2);
    } catch (e) {
      return String(val);
    }
  }
}
